// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"1102":"xlsx","7133":"pdfmake","7182":"canvg"}[chunkId] || chunkId) + ".js";
};